import { Directive } from '@angular/core';

@Directive({
  selector: '[simTimepicker]'
})
export class TimepickerDirective {
  constructor() {}
}
